import { render } from "./PieGraph.vue?vue&type=template&id=1cb6c4cf"
import script from "./PieGraph.vue?vue&type=script&lang=js"
export * from "./PieGraph.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__